import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({}, km({

  ME_GET_DETAIL_SUCCESS: null,
  ME_GET_DETAIL_ERROR: null,
  ME_GETTER_GET_DETAIL: null,
  ME_DETAIL_CHANGE_NICKNAME: null,
  ME_DETAIL_CHANGE_GENDER: null,
  ME_DETAIL_CHANGE_BIRTHDAY: null,
  ME_DETAIL_CHANGE_HEADICON: null,  
  ME_FEEDBACK_ERROR: null,
  ME_FEEDBACK_SUCCESS: null,
  ME_FEEDBACK_GET_STATUS: null,

  ME_GET_PAGE_SUCCESS: null,
  ME_GET_PAGE_ERROR: null,

  ME_NO_WATCH_COUNT_SUCCESS: null,
  ME_NO_WATCH_COUNT_ERROR: null,
}))
